import React from "react";

/**
 * PageHeader — unified premium header (eyebrow / title / subtitle + right slot).
 * Visual reference: LiveTracking + Drivers admin pages.
 *
 * Props:
 *  - eyebrow: short mono uppercase pre-title
 *  - title: main page title (font-display black uppercase)
 *  - subtitle: muted helper line
 *  - meta: optional inline chips/pills rendered under subtitle
 *  - actions: ReactNode rendered top-right (buttons)
 *  - backTo: optional { href, label } back link rendered above eyebrow
 */
export function PageHeader({ eyebrow, title, subtitle, meta, actions, backTo, testId }) {
  return (
    <header data-testid={testId} className="mb-6">
      {backTo && (
        <a
          href={backTo.href}
          className="inline-flex items-center gap-1 text-xs font-mono uppercase tracking-widest text-zinc-500 hover:text-zinc-900 mb-3"
        >
          ← {backTo.label}
        </a>
      )}
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div className="min-w-0">
          {eyebrow && (
            <div className="text-[10px] font-mono tracking-[0.3em] uppercase text-zinc-500">
              {eyebrow}
            </div>
          )}
          <h1 className="font-display font-black uppercase text-3xl lg:text-5xl tracking-tighter leading-[1.05]">
            {title}
          </h1>
          {subtitle && <p className="text-sm text-zinc-600 mt-2 max-w-2xl">{subtitle}</p>}
          {meta && <div className="mt-3 flex flex-wrap gap-2">{meta}</div>}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </header>
  );
}
